import React from 'react'
import PropTypes from 'prop-types'
import { RadioGroup, Clipped } from '@deseretbook/react-ui'
import PaymentSourceDetails from './PaymentSourceDetails'

/**
 * Reusable form field for displaying a user's wallet payment sources.
 */
const WalletPaymentSourcesFormField = ({
  sources,
  value,
  onChange,
  name,
  ...rest
}) => (
  <RadioGroup
    aria-label="Payment Source"
    selectedValue={String(value)}
    onChange={onChange}
    name={name}
    {...rest}
  >
    {
      sources
        .map(({ id, paymentSource }) => (
          <RadioGroup.Option value={String(id)} key={id}>
            <Clipped>
              <PaymentSourceDetails source={paymentSource} />
            </Clipped>
          </RadioGroup.Option>
        ))
    }
  </RadioGroup>
)

WalletPaymentSourcesFormField.propTypes = {
  /** Input field name */
  name: PropTypes.string.isRequired,
  /** onChange handler for when the input field value changes */
  onChange: PropTypes.func.isRequired,
  /** Available wallet payment methods */
  sources: PropTypes.array,
  /** Currently selected value (id of selected wallet payment method) */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

WalletPaymentSourcesFormField.defaultProps = {
  sources: [],
  value: '',
}

export default WalletPaymentSourcesFormField
